import { ClientToast, StaticLiveInput } from '@ecosystem/newron-client-lib';
import { Notification } from '@ecosystem/newron-design-system/build/components/notifications/types';
import React, { useCallback, useEffect, useState } from 'react';

import { ConfirmationModal } from '../ConfirmationModal/ConfirmationModal';

import { AddCollectionName } from './AddCollectionName';
import { AddInsightDescription } from './AddInsightDescription';
import { AddInsightName } from './AddInsightName';

export interface InsightModalMessage {
  message: string;
  type: Notification;
}
export type InsightModalProps = {
  children: React.ReactNode;
  isOpen?: boolean;
  message: InsightModalMessage;
  onClose: () => void;
  onError?: (e: Error) => void;
  onMessageDismiss: () => void;
  onSave: () => Promise<void>;
  title: string;
  valid: boolean;
  saveButtonText: string;
};

export function InsightModal({
  children,
  isOpen,
  message,
  onClose,
  onError,
  onMessageDismiss,
  onSave,
  title,
  valid,
  saveButtonText,
}: InsightModalProps): JSX.Element {
  const [toast, setToast] = useState<InsightModalMessage>();

  const handleOnSave = useCallback(async () => {
    await onSave().catch(e => {
      onError?.(e);
      throw new Error(e);
    });
  }, [onError, onSave]);

  const handleClearMessage = useCallback(() => {
    setToast(undefined);
    onMessageDismiss();
  }, [onMessageDismiss]);

  useEffect(() => {
    setToast(message);
  }, [message]);

  return (
    <>
      <ConfirmationModal
        title={title}
        onCancel={onClose}
        onConfirm={handleOnSave}
        isOpen={isOpen}
        isDisabled={!valid}
        label={saveButtonText}
      >
        {children}
      </ConfirmationModal>
      {toast && (
        <ClientToast type={toast.type} onComplete={handleClearMessage}>
          {toast.message}
        </ClientToast>
      )}
    </>
  );
}

InsightModal.CollectionNameInput = AddCollectionName;
InsightModal.InsightNameInput = AddInsightName;
InsightModal.InsightDescriptionInput = AddInsightDescription;
InsightModal.CollectionStaticLiveInput = StaticLiveInput;
